export interface EvaluateSource {
  aiScorePrediction?: number | string | null;
  aiEvaluate?: number | string | null;
}

const toScore = (value: number | string | null | undefined): number | undefined => {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  const score = Number(value);
  return Number.isNaN(score) ? undefined : score;
};

export const getEffectiveAiScore = (item: EvaluateSource): number | undefined => {
  const predictionScore = toScore(item?.aiScorePrediction);
  if (predictionScore !== undefined && predictionScore > 0) {
    return predictionScore;
  }

  return toScore(item?.aiEvaluate);
};
